<app-selection-list-modal
  [id]="id"
  [title]="title"
  [searchPlaceholder]="searchPlaceholder"
  [fetchConfig]="fetchConfig"
  [sections]="{
    columns,
    contentHeader: sections.contentHeader,
    disclaimer: sections.disclaimer,
    footer: sections.footer ?? defaultFooter
  }"
  [filters]="filters"
  [emptyMessage]="emptyMessage"
  (cancel)="onCancel()"
>
  <ng-template #actionsHeader></ng-template>
  <ng-template #actionsCell let-item>
    <mat-checkbox
      class="select-checkbox"
      color="primary"
      [attr.data-name]="id + '-select-item'"
      [checked]="selection.isSelected(item)"
      (click)="$event.stopPropagation()"
      (change)="onChange(item)"
    ></mat-checkbox>
  </ng-template>

  <ng-template #defaultFooter>
    <div class="default-footer">
      <div class="selected-label" *ngIf="selection.selected.length">
        <ng-container
          *ngTemplateOutlet="
            sections.selectedLabel ?? defaultSelectedLabel;
            context: { $implicit: selection.selected.length }
          "
        ></ng-container>
      </div>
      <app-pencil-button
        class="btn-submit pencil-button light medium"
        icon="close"
        buttonType="button"
        [iconConfig]="{
          type: 'material-icon'
        }"
        [label]="cancelButtonText || ('Cancel' | translate)"
        [attr.data-name]="id + '-cancel'"
        (clickEvent)="onCancel()"
      >
      </app-pencil-button>
      <app-pencil-button
        class="btn-submit pencil-button primary medium"
        icon="done"
        [disabled]="selection.selected.length === 0"
        [iconConfig]="{
          type: 'material-icon'
        }"
        [label]="doneButtonText || ('Done' | translate)"
        [attr.data-name]="id + '-submit'"
        (clickEvent)="onConfirm()"
      >
      </app-pencil-button>
    </div>
  </ng-template>
</app-selection-list-modal>

<ng-template #defaultSelectedLabel let-count>
  {{ '{{count}} selected' | translate: { count } }}
</ng-template>
